import React from 'react';
import QRCode from "react-qr-code";
import Themes from '../Themes';

function PdfInfo({ theme, H2, fontP, tentative, url, textColor }) {
  const Components = Themes[theme];

  const heroPdf = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };
  
  const aturCaraMajlis = JSON.parse(tentative);

  return (
    <div className={`${Components.themeColor} a6-section w-[105mm] h-[148mm] relative flex flex-col justify-center items-center overflow-hidden ${textColor}`} style={heroPdf} >
      <div className={`${Components.whiteBg} p-4`}>
        <div className={`${Components.tStyle}`}>
          <h1 className={`text-xs mb-8 uppercase font-bold ${fontP}`}>Schedule</h1>
          {aturCaraMajlis.map((item, index) => (
            <div key={index} className={`my-4 ${fontP}`}>
              <p className="text-xs">{item.title}:</p>
              <p className="text-xs">{item.displaytime}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-col items-center space-y-2 text-center mt-10">
          <QRCode value={url} size={50} />
          <div className=''>
            <p className="text-xs">Scan QR Code for</p>
            <p className="text-xs">more info</p>
          </div>
        </div>
      </div>
      <img
        src={Components.ft}
        className={Components.ftPdf}
      />
      <img
        src={Components.fb}
        className={Components.fbPdf}
      />
    </div>
  );
}

export default PdfInfo;
